const DIFFICULTY_EASY = 'DIFFICULTY_EASY';
const DIFFICULTY_NORMAL = 'DIFFICULTY_NORMAL';
const DIFFICULTY_HARD = 'DIFFICULTY_HARD';
const DIFFICULTY_NIGHTMARE = 'DIFFICULTY_NIGHTMARE';

const GAME_DIFFICULTY_NORMAL = 'GAME_DIFFICULTY_NORMAL';
const GAME_DIFFICULTY_HARD = 'GAME_DIFFICULTY_HARD';
const GAME_DIFFICULTY_EXPERT = 'GAME_DIFFICULTY_EXPERT';
const GAME_DIFFICULTY_MASTER = 'GAME_DIFFICULTY_MASTER';
const GAME_DIFFICULTY_TORMENT_1 = 'GAME_DIFFICULTY_TORMENT_1';
const GAME_DIFFICULTY_TORMENT_2 = 'GAME_DIFFICULTY_TORMENT_2';
const GAME_DIFFICULTY_TORMENT_3 = 'GAME_DIFFICULTY_TORMENT_3';
const GAME_DIFFICULTY_TORMENT_4 = 'GAME_DIFFICULTY_TORMENT_4';
const GAME_DIFFICULTY_TORMENT_5 = 'GAME_DIFFICULTY_TORMENT_5';
const GAME_DIFFICULTY_TORMENT_6 = 'GAME_DIFFICULTY_TORMENT_6';
const GAME_DIFFICULTY_TORMENT_7 = 'GAME_DIFFICULTY_TORMENT_7';
const GAME_DIFFICULTY_TORMENT_8 = 'GAME_DIFFICULTY_TORMENT_8';
const GAME_DIFFICULTY_TORMENT_9 = 'GAME_DIFFICULTY_TORMENT_9';

export const gameDifficulties = {
  normal: GAME_DIFFICULTY_NORMAL,
  hard: GAME_DIFFICULTY_HARD,
  expert: GAME_DIFFICULTY_EXPERT,
  master: GAME_DIFFICULTY_MASTER,
  torment1: GAME_DIFFICULTY_TORMENT_1,
  torment2: GAME_DIFFICULTY_TORMENT_2,
  torment3: GAME_DIFFICULTY_TORMENT_3,
  torment4: GAME_DIFFICULTY_TORMENT_4,
  torment5: GAME_DIFFICULTY_TORMENT_5,
  torment6: GAME_DIFFICULTY_TORMENT_6,
  torment7: GAME_DIFFICULTY_TORMENT_7,
  torment8: GAME_DIFFICULTY_TORMENT_8,
  torment9: GAME_DIFFICULTY_TORMENT_9,
};

export const gameDifficultyArray = [
  GAME_DIFFICULTY_NORMAL,
  GAME_DIFFICULTY_HARD,
  GAME_DIFFICULTY_EXPERT,
  GAME_DIFFICULTY_MASTER,
  GAME_DIFFICULTY_TORMENT_1,
  GAME_DIFFICULTY_TORMENT_2,
  GAME_DIFFICULTY_TORMENT_3,
  GAME_DIFFICULTY_TORMENT_4,
  GAME_DIFFICULTY_TORMENT_5,
  GAME_DIFFICULTY_TORMENT_6,
  GAME_DIFFICULTY_TORMENT_7,
  GAME_DIFFICULTY_TORMENT_8,
  GAME_DIFFICULTY_TORMENT_9,
];

export const gameDifficulty = {
  GAME_DIFFICULTY_NORMAL: {
    name: 'Normal',
  },
  GAME_DIFFICULTY_HARD: {
    name: 'Hard',
  },
  GAME_DIFFICULTY_EXPERT: {
    name: 'Expert',
  },
  GAME_DIFFICULTY_MASTER: {
    name: 'Master',
  },
  GAME_DIFFICULTY_TORMENT_1: {
    name: 'Torment 1',
  },
  GAME_DIFFICULTY_TORMENT_2: {
    name: 'Torment 2',
  },
  GAME_DIFFICULTY_TORMENT_3: {
    name: 'Torment 3',
  },
  GAME_DIFFICULTY_TORMENT_4: {
    name: 'Torment 4',
  },
  GAME_DIFFICULTY_TORMENT_5: {
    name: 'Torment 5',
  },
  GAME_DIFFICULTY_TORMENT_6: {
    name: 'Torment 6',
  },
  GAME_DIFFICULTY_TORMENT_7: {
    name: 'Torment 7',
  },
  GAME_DIFFICULTY_TORMENT_8: {
    name: 'Torment 8',
  },
  GAME_DIFFICULTY_TORMENT_9: {
    name: 'Torment 9',
  },
};

export const ruleCounts = {
  DIFFICULTY_EASY: {
    initialRuleCount: 3,
    phaseRuleCount: 1,
    phaseGoalCounts: {
      1: 0,
      2: 0,
      3: 1,
      4: 0,
      5: 1,
      6: 0,
      7: 0,
    },
    startingGameDifficulty: gameDifficulties.normal,
    displayName: 'Normal',
    tokensPerPhase: 15,
    ruleRollCost: 50,
  },
  DIFFICULTY_NORMAL: {
    initialRuleCount: 4,
    phaseRuleCount: 1,
    phaseGoalCounts: {
      1: 0,
      2: 1,
      3: 0,
      4: 1,
      5: 0,
      6: 1,
      7: 0,
    },
    startingGameDifficulty: gameDifficulties.hard,
    displayName: 'Nightmare',
    tokensPerPhase: 20,
    ruleRollCost: 75,
  },
  DIFFICULTY_HARD: {
    initialRuleCount: 5,
    phaseRuleCount: 1,
    phaseGoalCounts: {
      1: 1,
      2: 0,
      3: 1,
      4: 0,
      5: 1,
      6: 1,
      7: 0,
    },
    startingGameDifficulty: gameDifficulties.expert,
    displayName: 'Hell',
    tokensPerPhase: 25,
    ruleRollCost: 100,
  },
  DIFFICULTY_NIGHTMARE: {
    initialRuleCount: 6,
    phaseRuleCount: 1,
    phaseGoalCounts: {
      1: 1,
      2: 1,
      3: 1,
      4: 1,
      5: 1,
      6: 1,
      7: 0,
    },
    startingGameDifficulty: gameDifficulties.master,
    displayName: 'Inferno',
    tokensPerPhase: 30,
    ruleRollCost: 150,
  },
};

export const difficultyArray = [
  DIFFICULTY_EASY,
  DIFFICULTY_NORMAL,
  DIFFICULTY_HARD,
  DIFFICULTY_NIGHTMARE,
];

export default {
  easy: DIFFICULTY_EASY,
  normal: DIFFICULTY_NORMAL,
  hard: DIFFICULTY_HARD,
  nightmare: DIFFICULTY_NIGHTMARE,
};
